import { createReducer, on } from '@ngrx/store';
import {
  ApiKeyFormModeChangedAction,
  ApiKeyFormPageRequestedAction,
  ApiKeyErroredAction,
  ApiKeyLoadedAction,
} from './api-key-form.actions';
import {
  AdminApiKeyErroredAction,
  AdminApiKeyFormModeChangedAction,
  AdminApiKeyFormPageRequestedAction,
  AdminApiKeyLoadedAction,
} from './admin-api-key-form.actions';
import { ApiKey } from '../api-key/api-key.model';
import { FormMode } from './api-key-form.model';
import { createMergedReducer } from '../../ngrx-helpers/adapters/utils';
import { apiKeyFormProjectsAdapter, ApiKeyFormProjectsState } from './api-key-form.adapter';
import { LoadError } from '../../ngrx-helpers/adapters/load/models';

interface FormState {
  model: ApiKey;
  mode: FormMode;
  loaded: boolean;
  error: LoadError;
}

const initialState: FormState = {
  model: null,
  mode: FormMode.View,
  loaded: false,
  error: null,
};

const formStateReducer = createReducer(
  initialState,
  on(ApiKeyFormPageRequestedAction, AdminApiKeyFormPageRequestedAction, (state) => ({
    ...state,
    error: null,
    loaded: false,
    model: null,
    mode: FormMode.View,
  })),
  on(ApiKeyLoadedAction, AdminApiKeyLoadedAction, (state, { apiKey }) => ({
    ...state,
    loaded: true,
    model: apiKey,
    error: null,
  })),
  on(ApiKeyErroredAction, AdminApiKeyErroredAction, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ApiKeyFormModeChangedAction, AdminApiKeyFormModeChangedAction, (state, { mode }) => ({
    ...state,
    mode,
    model: mode === FormMode.Create ? null : state.model,
    loaded: false,
    error: null,
  })),
);

export interface ApiKeyFormState extends ApiKeyFormProjectsState, FormState {}

export const apiKeyFormReducer = createMergedReducer(
  apiKeyFormProjectsAdapter.getReducer(),
  formStateReducer,
);
